import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { FetchResult } from 'apollo-link'
import { IFloorMapSpace } from '../types'

type IBookDesk = {
  viewer: {
    company: {
      spaceConnection: {
        edges: IFloorMapSpace[]
      }
    }
  }
}

export default function fetchBookingDesks(
  toDate: string,
  fromDate: string,
  floorId: string | null,
  assignmentPlanId: string,
  usageTypeId_in: string[] | null,
  employeeId: string | undefined
): Promise<FetchResult<IBookDesk>> {
  const variables = {
    toDate,
    fromDate,
    where: {
      AND: [
        {
          floorId,
          assignmentPlanId,
          usageTypeId_in,
        },
      ],
    },
    employeeId,
  }

  return client.gql.query({ query, variables })
}

export const query = gql`
  query spaceStuff($where: SpaceWhereInput, $fromDate: String!, $toDate: String!, $employeeId: ID) {
    viewer {
      company {
        spaceConnection(where: $where) {
          edges {
            node {
              id
              isBookableByEmployee(employeeId: $employeeId)
              isBookableUsageType(employeeId: $employeeId)
              dailyBookableSpacesAvailability(fromDate: $fromDate, toDate: $toDate) {
                availability
                bookings {
                  ... on Booking {
                    id
                    startDate
                    endDate
                    employee {
                      id
                      name
                      email
                      assets {
                        id
                        url
                      }
                    }
                    healthCheck {
                      locationHeathCheckGroup {
                        id
                      }
                      disabled
                    }
                  }
                }
              }
              w
              x
              y
              code
              density
              externalId
              name
              comment
              spaceAssignment {
                team {
                  id
                  name
                }
                department {
                  id
                  name
                }
                neighborhood {
                  employees {
                    id
                    name
                    email
                    dept: department {
                      id
                      name
                    }
                    team {
                      id
                      name
                    }
                  }
                }
                employee {
                  id
                  name
                  email
                  dept: department {
                    id
                    name
                  }
                  team {
                    id
                    name
                  }
                }
                sharedEmployees {
                  id
                  name
                  email
                  department {
                    id
                    name
                  }
                  team {
                    id
                    name
                  }
                }
                sharedDepartments {
                  id
                }
              }
              workplaceGroup {
                id
                name
              }
              usageType {
                name
                displayName
              }
              spaceType {
                name
                interactivityType
              }
              tags {
                id
                name
              }
              floor {
                building {
                  timezone
                }
                id
              }
            }
          }
        }
      }
    }
  }
`
